// src/actions/authActions.js
import { LOGIN, LOGOUT } from './actionTypes';

export const login = (kiosk_token) => ({
    type: LOGIN,
    payload: kiosk_token,
});

export const logout = () => ({
    type: LOGOUT,
});